import BordableProperty from '../BordableProperty';

export default class RectangleSettingsProperty extends BordableProperty {

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }
    
    toString() {
        return "设置";
    }
}
